import { OnUpdateCriteriaFieldOptions } from '@widgets/SearchAssistant/model/types'
import { SearchAssistantPresenter } from '@widgets/SearchAssistant/presenter/search-assistant.presenter'

import { CriteriaType, ValueAddType } from '@constants'
import { AutocompleteOption } from '@types'

import { CriteriaFields } from './CriteriaFields'

interface PinnedCriteriaFieldsProps {
  searchAssistantPresenter: SearchAssistantPresenter
  visibleCriterias: CriteriaType[]
  disabled: boolean
  onUpdateAutocomplete: (
    newCriteria: CriteriaType,
    newValue: AutocompleteOption,
    options: OnUpdateCriteriaFieldOptions
  ) => void
  onUpdateCriteriaValue: (value: ValueAddType) => void
}

export const PinnedCriteriaFields: React.FC<PinnedCriteriaFieldsProps> = props => {
  const {
    searchAssistantPresenter,
    visibleCriterias,
    disabled,
    onUpdateAutocomplete,
    onUpdateCriteriaValue: handleUpdateCriteriaValue,
  } = props

  const visiblePinnedCriteriaFields =
    searchAssistantPresenter.getVisiblePinnedCriteriaFields(visibleCriterias)

  const handleUpdateAutocomplete = (newCriteria: CriteriaType, newValue: AutocompleteOption) => {
    onUpdateAutocomplete(newCriteria, newValue, { pinned: true })
  }

  return (
    <CriteriaFields
      criterias={visiblePinnedCriteriaFields}
      disabled={disabled}
      onUpdateAutocomplete={handleUpdateAutocomplete}
      onUpdateCriteriaValue={handleUpdateCriteriaValue}
    />
  )
}

PinnedCriteriaFields.displayName = 'PinnedCriteriaFields'
